export const Role = {
    Admin: 'ADMIN',
    Super: 'SUPER',
    ComplianceStudent: 'COMPLIANCESTUDENT',
    ComplianceStaff: 'COMPLIANCESTAFF',
    ComplianceAdmin: 'COMPLIANCEADMIN',
}